




























import Vue, { PropType } from 'vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export type DataType = {
  cropper: any | null;
};

export default Vue.extend({
  name: 'GImageCrop',
  components: {
    VueCropper,
  },
  props: {
    aspect: {
      type: Number as PropType<number>,
      default: null,
    },
    isCircle: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    src: {
      type: String as PropType<string>,
      default: '',
    },
  },
  data(): DataType {
    return {
      cropper: null,
    };
  },
  methods: {
    cancelCrop() {
      this.$emit('cancel');
      this.cropper.reset();
      this.cropper.destroy();
    },
    crop() {
      if (this.cropper) {
        this.cropper.getCroppedCanvas().toBlob((blob: Blob) => {
          this.$emit('croped', blob);
          this.cropper.reset();
          this.cropper.destroy();
        });
      }
    },
  },
  async mounted() {
    this.cropper = this.$refs.cropper;
  },
});
